export default (state = { loading: false, user: {}, error: null }, action) => {
  if(!action){
    return state;
  }
  switch (action.type) {
    case 'user/LOADING':
      return {
        ...state,
        user: {},
        error: null,
        loading: true
      };

    case 'user/SET_USER':
      return {
        ...state,
        user: {
          ...action.payload
        },
        loading: false
      };

    case 'SET_LOGIN':
      return {
        ...state,
        auth: action.paySetLogin
      };
    case 'SET_LOGOUT':
      return {
        ...state,
        user: {}
      };

    default:
      return state;
  }
};
